class AssertionError extends Error {}

export { AssertionError };

export default (condition, message) => {
  if (!condition) {
    throw new AssertionError(`ASSERTION ERROR:
      ${message}
    `);
  }
};
